import { FormEvent } from "react";
import useImmolizedStore from "../store/useStore";
import ButtonRows from "./Rows/ButtonRows";
import { generateObject, tratamentObject } from "../libs/generateObject";
import useAuthData from "../../../../../../hook/useAppData";
import { postImmobilized, putImmobilized } from "../../service";
import { toastError } from "../../../../../../components/Toast";
import { Toaster } from "react-hot-toast";
import Row1And2 from "./Rows/Row1And2";
import Row3And4 from "./Rows/Row3And4";
import Row5 from "./Rows/Row5";

export function FormImmobilizedInventory(props) {
  const { token } = useAuthData();
  const { defaultValues, handleExitClick, createOrUpdate, state } = useImmolizedStore();

  const params = props?.params;

  function handleSubmitForm(event: FormEvent) {
    event.preventDefault();
    const objGenerated = generateObject(defaultValues, state);
    const objTreated = tratamentObject(objGenerated);
    postOrUpdate(objTreated);
  }

  function postOrUpdate(obj) {
    if (createOrUpdate === "create") return post(obj);
    return update(obj);
  }

  async function post(obj) {
    const res = await postImmobilized(obj, token);
    verefyRes(res);
  }

  async function update(obj) {
    const res = await putImmobilized(params, obj, token);
    verefyRes(res);
  }

  async function verefyRes(res) {
    // const data = await res?.json();
    // console.log(data);
    if (res?.ok) return handleExitClick();
    return toastError(`Nao foi possível realizar essa ação, verifique e tente novamente!`);
  }

  return (
    <>
      <Toaster />
      <form onSubmit={(event: FormEvent) => handleSubmitForm(event)} className="box-form form-container">
        <Row1And2 />
        <Row3And4 />
        <Row5 />
        <ButtonRows />
      </form>
    </>
  );
}
